import api from '@/api/index.js'

const account_emv_tap = {
  state: {
    loading: false,
    updating: false,
    data: null,
    // createdMoneyClaimId: null,
    // updatedMoneyClaim: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_EMV_TAP_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_EMV_TAP_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_EMV_TAP: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_EMV_TAP_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountEmvTap({commit}, req) {
      commit('SET_ACCOUNT_EMV_TAP_LOADING', true)
      commit('SET_ACCOUNT_EMV_TAP_ERROR', null)
      return api.get(`accounts/${req.accountID}/emv-taps/${req.resourceId}`)
        .then((response) => {
          commit('SET_ACCOUNT_EMV_TAP', response)
          commit('SET_ACCOUNT_EMV_TAP_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_EMV_TAP_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_emv_tap
